// Document ready
$(function(){

    // Select fields
    // Select2 Library
    $(".select-js").each(function () {
        $(this).select2({
            minimumResultsForSearch: -1 // hide search box
        });
     });
});
